import { DELETE, GET, PATCH, POST } from '../../common/common.service'
import endpointsNeeds from './endpoints'

export const NeedsService = {
  getAll: async ({ filter, sort, limit, skip }) =>
    GET(endpointsNeeds.LOAD(filter, sort, limit, skip)),
  createNeeds: async (body) => POST(endpointsNeeds.LOAD(), body),
  updateNeed: async ({ needId, elementId }) =>
    PATCH(endpointsNeeds.NEED_ADD_TO_CAR(needId, elementId)),
  addToCart: async (body) => POST(endpointsNeeds.ADD_TO_CART, body),
  activateAll: async (needId) => PATCH(endpointsNeeds.ACTIVE_ALL(needId)),
  desactivateAll: async (needId) => PATCH(endpointsNeeds.DESACTIVE_ALL(needId)),
  remove: async (id) => DELETE(endpointsNeeds.BY_ID(id)),
}
